import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { useSelector } from 'react-redux';

function Navbar() {
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const { cartTotalQuantity } = useSelector((state) => state.counter);


  useEffect(() => {
    const fetchData = async () => {

      const response = await axios.get("https://fakestoreapi.com/products/")

      setData(response.data)

    }
    fetchData()
  }, []);


  const onSearch = (searchTerm) => {
    setSearch(searchTerm);


  }
  const onCancel = () => {
    setSearch('');


  }


  return (

    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
        <div className="container-fluid mx-lg-5 mx-sm-0">
          <Link className="navbar-brand fw-bold fs-4" to="/">HR COLLECTIONS</Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/"><i className="fa-sharp fa-solid fa-house"></i> Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/products">Product</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/"><i className="fa-solid fa-user"></i> About</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/"><i className="fa-solid fa-phone"></i> Contact</Link>
              </li>


            </ul>


          </div>
          <div className='d-flex mt-lg-0 mt-xs-5 '>
            <input className="form-control me-2  input-box " type={'text'} placeholder="Search" aria-label="Search" value={search} onChange={(e) => { setSearch(e.target.value) }} />
            <button className="btn bttns" onClick={onCancel}><i className="fa-solid fa-multiply"></i></button>
            <div className="btns  bg-none ms-3 " onClick={() => navigate('/cart')}><i class="fa-solid fa-cart-shopping"></i> <span className='Cart'>{cartTotalQuantity} </span></div>
          </div>

        </div>
      </nav>
      <div className='box' >
        {
          data.filter(item => {
            const searchTerm = search.toLowerCase();
            const title = item.title.toLowerCase();

            return searchTerm && title.startsWith(searchTerm) && title !== searchTerm

          })


            .map((item) => <div onClick={() => onSearch(item.title)} key={item.id} className='dropdown-row' ><Link className='searchFont' to={`/productDet/${item.id}`}>{item.title}</Link></div>

            )}
      </div>
    </>

  )
}

export default Navbar
